import React from "react";
import {ImgComponent, substituteZeroWithLine} from "src/utils/utility";
import Icon from "../../../Icon/Sprite";
import {ICONS} from "src/assets/sprite/iconsNames";
import GreyLogo from "../../../../assets/logo/logo-VT-grey.svg";

function ListInputMobileOffertUser(props) {

    const {element} = props

    return (
        <div className="width-100">
            <div className="flex-between">
                <div className="flex-column">
                    <div className="blue underlined weight-700 size-16">{element.title}</div>
                    {element.anonymous ?
                        <div className="opacity-50 underlined size-12">
                            Azienda Anonima
                        </div> :
                        <div className="opacity-50 underlined weight-400 size-12">
                            {element.location && element.location.name}
                        </div>}
                    <div className="flex-row dividerDot">
                        {element.insertMode &&
                        <div className="flex-center">
                            {element.insertMode}
                        </div>
                        }
                        {element.workPlace &&
                        <div className="flex-center">
                            {element.workPlace}
                        </div>
                        }
                    </div>
                    <div className="flex-row dividerDot">
                        {element.location && element.location.city &&
                        <div className="flex-center">
                            {element.location.city}
                        </div>
                        }
                        {element.impegnoRichiesto &&
                        <div className="flex-center">
                            {element.impegnoRichiesto}
                        </div>
                        }
                    </div>
                    <div>
                        <Icon color="grey" name={ICONS.user_ok}
                              size={[20, 20]}/>
                        <span className="margin-left-5">
                            {substituteZeroWithLine(element && element.candidateCount)}
                        </span>
                    </div>
                </div>
                <div style={{height: "55px", width: "80px"}}>
                    {!element.anonymous ?
                        <ImgComponent logoPath={element.company && element.company.logoPath}/>
                        :
                        <div className="noLogo">
                            <img src={GreyLogo}/>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default ListInputMobileOffertUser